import PropTypes from 'prop-types';
import React from 'react';
import FormattedTranslation from 'components/Common/FormattedTranslationMui';
import Cancel from '@mui/icons-material/Cancel';
import { Box, Button } from '@mui/material';
import Message from './Message';
import TinyMessage from './TinyMessage';

const icon = <Cancel />;

const ErrorMessage = ({ children, onContinue, onRetry, tiny, title, gutterBottom }) => (
  tiny ? (
    <TinyMessage color="error.main" icon={icon}>
      {children}
    </TinyMessage>
  ) : (
    <Message gutterBottom={gutterBottom} titleColor="inherit" color="error.main" icon={icon} title={title}>
      <>
        <Box>
          {children}
        </Box>
        {
          (typeof onContinue === 'function' || typeof onRetry === 'function') && (
            <Box mt={2} textAlign="center">
              {
                typeof onContinue === 'function' && (
                  <Button variant="contained" onClick={onContinue}>
                    <FormattedTranslation id="general.button.requestNewLink" />
                  </Button>
                )
              }
              {
                typeof onRetry === 'function' && (
                  <Button variant="contained" onClick={onRetry}>
                    <FormattedTranslation id="general.error.retry" />
                  </Button>
                )
              }
            </Box>
          )
        }
      </>
    </Message>
  ));

ErrorMessage.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  onContinue: PropTypes.func,
  onRetry: PropTypes.func,
  tiny: PropTypes.bool,
  title: PropTypes.string,
  gutterBottom: PropTypes.bool,
};

ErrorMessage.defaulProps = {
  tiny: false,
  gutterBottom: false,
};

export default ErrorMessage;
